import EditorGateway from "../../gateways/editor_gateway";

export default {
  name: 'editorGateway',
  fn: EditorGateway
};